import { DeprecatedApiService, OrganizationResource } from '@mode/legacy/data-access-model-js';
import { AppStore } from '~/types/main.types';

export class IdentityService {
  static $inject = ['ApiService', 'OrgSettingsService', 'RxStoreService'];

  constructor(
    private api: DeprecatedApiService,
    private OrgSettingsService,
    private rxStoreService: AppStore
  ) {}

  public getOrgWithProviders(): Promise<OrganizationResource> {
    return this.OrgSettingsService.currentOrganization({
      includes: [
        'easy_identity_providers',
        'saml_identity_providers',
        'new_scim_token',
        'scim_token',
        'organization_features',
      ],
    }).then((currentOrgResponse) => currentOrgResponse._resource);
  }

  public getEasyIdentity(org: OrganizationResource) {
    return this.api.getResource(org, 'easy_identity_providers');
  }

  public getSamlIdentity(org: OrganizationResource) {
    return this.api.getResource(org, 'saml_identity_providers');
  }

  public getSamlAndEasyIdentities(org: OrganizationResource) {
    const identityCalls = Promise.all([this.getEasyIdentity(org), this.getSamlIdentity(org)]);

    return identityCalls.then(([easyIdentityResponse, samlIdentityResponse]) => ({
      easy: easyIdentityResponse,
      saml: samlIdentityResponse,
    }));
  }
}
